import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/**
 * Dialog for confirming discarding changes
 */
export const DiscardChangesDialog = ({ open, onCancel, onDiscard }) => {
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			aria-describedby="alert-dialog-slide-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-slide-description">
					Are you sure you want to discard all changes made?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onDiscard}>Discard Changes</Button>
				<Button onClick={onCancel}>Cancel</Button>
			</DialogActions>
		</Dialog>
	);
};

/**
 * Dialog for showing validation errors
 */
export const ValidationErrorDialog = ({ open, onClose, errorMessage }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-describedby="alert-dialog-slide-description"
		>
			<DialogTitle>{"Error occurred for results in -"}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-slide-description">
					<pre>{errorMessage}</pre>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>OK</Button>
			</DialogActions>
		</Dialog>
	);
};
